import { PeopleContentService } from '@alfresco/adf-content-services';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WkPeopleContentService {
  constructor(private readonly peopleContentService: PeopleContentService) {}

  getPerson(personId: string): Observable<any> {
    return this.peopleContentService.getPerson(personId);
  }
}
